function r(e) {
  return e.size[0] * e.size[1];
}
export {
  r as getGrossVerticalArea
};
//# sourceMappingURL=index.js.map
